import React from 'react';
import { useEditorStore } from '../store/editorStore';

const StatusBar: React.FC = () => {
  const { project, activeFileId } = useEditorStore();
  const activeFile = project.files[activeFileId];

  const getLanguageFromExtension = (filename: string) => {
    if (filename.endsWith('.html')) return 'HTML';
    if (filename.endsWith('.css')) return 'CSS';
    if (filename.endsWith('.js')) return 'JavaScript';
    if (filename.endsWith('.ts')) return 'TypeScript';
    if (filename.endsWith('.json')) return 'JSON';
    return 'Unknown';
  };

  return (
    <div className="h-6 bg-blue-900 px-4 flex items-center justify-between text-xs text-blue-200 border-t border-blue-800">
      <div className="flex items-center gap-4">
        <span>{activeFile?.name || 'No file'}</span>
        <span>{getLanguageFromExtension(activeFile?.name || '')}</span>
        <span>UTF-8</span>
      </div>
      <div className="flex items-center gap-4">
        <span>行 {activeFile?.content?.split('\n').length || 0}</span>
        <span>空格: 2</span>
      </div>
    </div>
  );
};

export default StatusBar;
